module.exports = __webpack_public_path__ + "img/orders.98fab8b3.svg";